// Constants for uploading state
export const UPLOAD_STATE_UPLOADING = 'uploading';
export const UPLOAD_STATE_IMPORTING = 'importing';
export const UPLOAD_STATE_UPLOADED = 'uploaded';
export const UPLOAD_STATE_FAILED = 'failed';
